import { createAction } from '@reduxjs/toolkit';

import type { AnyApi } from '../../buildCreateApi';
import type { PayloadAction } from '../../rtk-types';

/**
 * Формат мета-информации в экшенах {reducerPath}/executeQuery/rejected.
 * Экшен создается внутри RTK Query, но не экспортируется.
 * Поля `arg` — подмножество `QueryThunkArg` из RTK Query.
 */
export type QueryRejectedAction = PayloadAction<
    unknown,
    string,
    {
        condition: boolean;
        requestId: string;
        arg: {
            queryCacheKey: string;
            endpointName: string;
            originalArgs: unknown;
        };
    },
    unknown
>;

/**
 * Создает функцию-матчер, которая определяет является ли экшен реджетом запроса.
 * @param api Инстанс RTK Query API.
 * @returns Функция-матчер, которая определяет является ли экшен реджектом запроса.
 */
export function createQueryRejectedActionMatcher<Api extends AnyApi>(api: Api) {
    const queryRejectedAction = createAction(`${api.reducerPath}/executeQuery/rejected`);

    return function match(action: unknown): action is QueryRejectedAction {
        return queryRejectedAction.match(action);
    };
}
